<template>
	<div @click="showModal">
		<template>
			<app-image :src="post.image" :class="$style.postImage" />
			<app-image
				v-if="post.typeId == 1 && post.isVideo == 1"
				src="/resources/images/video.png"
				style="position: absolute; top: 10px; left: 10px;"
			/>
			<app-image
				v-if="post.typeId == 2"
				src="/resources/images/igtv.png"
				style="position: absolute; top: 10px; left: 10px;"
			/>
			<app-image
				v-if="post.typeId == 3"
				src="/resources/images/reels.png"
				style="position: absolute; top: 10px; left: 10px;"
			/>
			<app-image
				v-if="post.typeId == 4"
				src="/resources/images/carrousel.png"
				style="position: absolute; top: 10px; left: 10px;"
			/>
			<app-image
				v-if="post.networkId == 2"
				src="/resources/images/instagram-logo.png"
				style="position: absolute; top: 10px; right: 10px;width:23px;"
			/>
			<app-image
				v-if="post.networkId == 3"
				src="/resources/images/youtube-logo.png"
				style="position: absolute; top: 10px; right: 10px;width:23px;"
			/>
			<app-image
				v-if="post.networkId == 5"
				src="/resources/images/tiktok-logo.png"
				style="position: absolute; top: 10px; right: 10px;width:23px;"
			/>
		</template>
		<a-modal
			:title="post.createdAt | moment('DD/MM/YYYY')"
			v-model="show"
			@cancel="handleHide"
			:width="500"
			:bodyStyle="{ padding: '0px' }"
			:footer="null"
			:destroyOnClose="true"
		>
			<div class="width-500">
				<template>
					<app-image :src="post.image" style="max-width:100%;" />
				</template>
			</div>
			<div class="py-2 bg-gray-1 pl-3">
				<div class="d-flex flex-wrap">
					<div class="d-flex flex-wrap font-size-16">
						<div class="mr-3 my-2 text-nowrap">
							<i class="fa fa-thumbs-o-up font-size-20 mr-1"></i>
							{{ post.likes }}
						</div>
						<div class="mr-3 my-2 text-nowrap">
							<i class="fa fa-eye font-size-20 mr-1"></i>
							{{ post.views }}
						</div>
						<div class="mr-3 my-2 text-nowrap">
							<i class="fa fa-comment font-size-20 mr-1"></i>
							{{ post.comments }}
						</div>
						<div class="mr-3 my-2 text-nowrap">
							<a
								v-if="post.networkId == 2"
								v-bind:href="'https://www.instagram.com/p/' + post.code"
								target="_blank"
							>
								go to post
							</a>
							<a
								v-if="post.networkId == 3"
								v-bind:href="`https://www.youtube.com/watch?v=${post.code}`"
								target="_blank"
							>
								go to post
							</a>
							<a
								v-if="post.networkId == 5"
								v-bind:href="
									`https://www.tiktok.com/@${post.detailProfileName}/video/${post.code}`
								"
								target="_blank"
							>
								go to post
							</a>
						</div>
					</div>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
// import AppVideo from '../Video'
import AppImage from '../Image'

export default {
	name: 'DetailImageModal',
	components: {
		// AppVideo,
		AppImage,
	},
	props: {
		post: {
			type: Object,
			required: true,
		},
	},
	data: function() {
		return {
			show: false,
		}
	},
	created() {},
	methods: {
		onError(e) {},
		handleHide() {
			this.show = false
		},
		showModal() {
			this.show = true
		},
	},
}
</script>

<style lang="scss" module>
@import './imagemodal.style.module.scss';
</style>
